// One /api/auth/session read per tab and moment, shared by every component that wants it.
// Nav, the formula sheet, the pairing button and every ScanLosning (one per photo task — a prov
// page has several) each fetched it on mount: 4 + N requests, each a database statement
// (the blocked/password check), for the same answer (prestandapass 2026-10-27). Calls within
// DELA_MS share one request; a later call (after a navigation, a login) asks again.
"use client";

const DELA_MS = 5_000;

let delad: { svar: Promise<unknown | null>; vid: number } | null = null;

/** The parsed /api/auth/session answer (shape T, the route's), or null when the request failed
 *  or was not ok. */
export function hamtaSessionSvar<T>(): Promise<T | null> {
  const nu = Date.now();
  if (delad && nu - delad.vid < DELA_MS) return delad.svar as Promise<T | null>;
  const svar = fetch("/api/auth/session", { cache: "no-store" })
    .then((r) => (r.ok ? (r.json() as Promise<unknown>) : null))
    .catch(() => null);
  delad = { svar, vid: nu };
  return svar as Promise<T | null>;
}
